// import axios from 'axios'

import vuex from '@/store.js'

class XRayService {
  constructor() {
    this.baseURL = 'https://xray.mission-five.io/set'
    this.projectID = 'showroom' // FIXME:
    this.logDevEvents = false
  }

  // "projectID": "showroom",
  // "labels": ["testing", "foo", "bar"],
  //   "eventType": "userevent",
  //   "eventSourceID": "unique-user-id",
  //   "eventData": {
  //     "action": "event-test",
  //     "client": "insomnia",
  //     "user": "nic",
  //     "attempt": 2
  //   }

  logEvent(event) {

    const staticEventData = {
      projectID: this.projectID,
      eventType: 'clientEvent',
      eventSourceID: vuex.getters.user.email || 'anonymous',
      eventTimestamp: new Date()
    }

    const e = Object.assign(event, staticEventData)

    if(process.env.NODE_ENV == 'development' && this.logDevEvents == false) {
      // eslint-disable-next-line no-console
      console.log(e)
      return
    }

    // FIXME: x-ray service is offline, log only to console in dev mode for now
    // axios.post(this.baseURL, 
    //   Object.assign(event, staticEventData),
    //   {
    //     headers: {
    //       'X-Authenticated-User': 'mission:five-only'
    //     }
    //   }
    // )
  }
}

export default new XRayService()